import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import { findAll } from "../../../../services/Client__Service";
import { notifyGestionnaire } from "../../../../services/Document__Servive";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import { ANNEE_TABS, MOIS_TABS } from "../../../../services/config";

const FormNotify = ({ initialClient = null }) => {
  const notify = useContext(notifyContext);
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [listClient, setListClient] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [notif, setNotif] = useState({
    mois: new Date().getUTCMonth() + 1,
    annee: new Date().getUTCFullYear(),
    client: null,
    clientId: 0,
  });

  useEffect(() => {
    if (initialClient?.id) {
      setNotif((value) => {
        return {
          ...value,
          client: initialClient,
          clientId: initialClient.id,
        };
      });
      setIsLoading(false);
    } else {
      fetchAllClient();
    }
  }, []);

  const fetchAllClient = async () => {
    findAll()
      .then((response) => {
        setListClient(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];
    if (notif.clientId === 0) {
      display_errors.push({
        message: "Veuillez sélectionner un client",
        id_input: "clientId",
      });
    }

    if (notif.mois === "") {
      display_errors.push({
        message: "Veuillez sélectionner le mois",
        id_input: "mois",
      });
    }

    if (notif.annee === "") {
      display_errors.push({
        message: "Veuillez sélectionner l'année",
        id_input: "annee",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      notifyGestionnaire({ ...notif })
        .then(() => {
          setIsSend(false);
          notify("Gestionnaire notifié avec succès", "success");
          window.location.reload(false);
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setNotif((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form-header">
          <div className="error">{error}</div>
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="clientId" className="form-label">
              Client <span className="required">*</span> :
            </label>
            {notif.client ? (
              <p>{notif.client.nom}</p>
            ) : (
              <select
                name="clientId"
                id="clientId"
                className="form-select"
                value={notif.clientId}
                onChange={handleChange}
              >
                <option value="0" disabled></option>
                {listClient.map((client) => {
                  const { id, nom } = client;
                  return (
                    <option key={id} value={id}>
                      {nom}
                    </option>
                  );
                })}
              </select>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="mois" className="form-label">
              Mois <span className="required">*</span> :
            </label>
            <select
              name="mois"
              id="mois"
              className="form-select"
              value={notif.mois}
              onChange={handleChange}
            >
              {MOIS_TABS.map((elt, key) => {
                return (
                  <option key={key} value={key + 1}>
                    {elt}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="annee" className="form-label">
              Année <span className="required">*</span> :
            </label>
            <select
              name="annee"
              id="annee"
              className="form-select"
              value={notif.annee}
              onChange={handleChange}
            >
              {ANNEE_TABS.map((item) => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Notifier
          </button>
        </div>
      </form>

      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default FormNotify;
